import { useEffect } from "react"
import { getBanner } from "./toolService"
import { useState } from "react"
import { useForm } from 'react-hook-form';
import { OffCanvas } from '../common';
import { useAuth } from '../auth/Authcontext';
import { toast } from 'react-toastify';
import { updateBanner } from "./toolService";

export default function Manageadvertisment() {

    const [bannerLink, setBannerLink] = useState("");
    const [bannerImage, setBannerImage] = useState("");

    const { register, handleSubmit, formState: { errors } } = useForm();
    const {contextValue } = useAuth();



    async function getBannerData() {

        contextValue.showLoader();



        const response = await getBanner();

        contextValue.hideLoader();


        
        const data = response.data

        if (data.redirectUrl) {
            setBannerLink(data.redirectUrl)
        }

        if (data.imageUrl) {
            setBannerImage(data.imageUrl)
        }
        console.log(data)
    }

    const onSubmit = (data) => {


        contextValue.showLoader();
        contextValue.updateLoaderText("Update banner...");



        const formData = new FormData();
        formData.append("RedirectUrl", data.RedirectUrl);

        updateBanner(formData)
        .then(response => {

            getBannerData();
            toast.success("Banner updated successfully");
           
        })
        .catch(error => {
            toast.error("Error updating banner");
        })
        .finally(() => {
            contextValue.hideLoader();
        });
        if (data.Image?.[0]) formData.append("Image", data.Image[0]);

        console.log(data)
    }

    useEffect(() => {
        getBannerData();
    }, [])
    return (
        <div className='container h-100 overflow-auto'>

            <div>
                {/* Heading + Button Row */}
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h1 className="h4 mb-0">Current banner settings</h1>
                    <button
                        className="btn btn-azure"
                        type="button"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#newShowForm"
                    >
                        Update banner setting
                    </button>
                </div>

                {/* Link */}
                <p>
                    <strong>Link:</strong>{" "}
                    <a href={bannerLink} target="_blank" rel="noopener noreferrer">
                        {bannerLink}
                    </a>
                </p>

                {/* Image */}
                <p><strong>Image:</strong></p>
                <div
                    style={{
                        width: "300px",
                        height: "200px",
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden",
                    }}
                >
                    <img
                        src={process.env.REACT_APP_AWS_S3 +bannerImage}
                        className="img-fluid"
                        alt="Banner"
                        style={{
                            maxWidth: "100%",
                            maxHeight: "100%",
                            objectFit: "contain", // keeps aspect ratio
                        }}
                    />
                </div>
            </div>


            <OffCanvas id='newShowForm' title='Update banner setting'>
                <div>
                    <p>Use this form to update the current advertisement shown on the front page of the app.</p>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="mb-3">
                            <label htmlFor="RedirectUrl" className="form-label">Link</label>
                            <input type="text" className="form-control" id="RedirectUrl"
                                autoComplete='off' {...register('RedirectUrl', { required: true })} />
                            {errors.RedirectUrl?.type === 'required' && <div className='text-danger form-text'>Link is required</div>}
                        </div>
                        <div className="mb-3">
                            <label htmlFor="Image" className="form-label">Image </label>
                            <br />
                            <input type="file" className="form-control" id="Image"
                                {...register('Image', { required: true })} />
                            <small>Image must be a 'png' or 'jpg'. Recommended size is 750x150.</small>
                            {errors.Image?.type === 'required' && <div className='text-danger form-text'>Image is required</div>}

                        </div>

                        <button className='btn btn-success text-white w-30' type='submit'>Submit</button>

                    </form>
                </div>
            </OffCanvas>


        </div>
    )
}